<template>
  <div class="ban">
    <van-nav-bar title="限用农药清单" style="z-index:2" left-arrow fixed @click-left="onClickLeft" />
    <div class="main">
      <van-tabs v-model="active" animated color="#31D181" line-width="80px">
        <van-tab title="不允许使用范围" name="a">
          <wh-mobile-list
            ref="listTable"
            class="list"
            :get-list-data="getListData"
            :extra-params="extraParams1"
            :data-src="dataSrc"
          >
            <template v-slot="{list}">
              <van-collapse v-model="activeName" accordion>
                <van-collapse-item v-for="i in list" :key="i.id" :title="i.name" :name="i.id">
                  <div><label>禁用原因:</label><p>{{ i.reason }}</p></div>
                  <div><label>禁用日期:</label><p>{{ i.ban_date }}</p></div>
                  <div><label>公告号/发布日期:</label><p>{{ i.notify_date }}</p></div>
                  <div><label>禁止在这些范围使用:</label><p>{{ i.scope.join() }}</p></div>
                  <div><label>简介:</label><p>{{ i.info }}</p></div>
                </van-collapse-item>
              </van-collapse>
            </template>
          </wh-mobile-list>
        </van-tab>
        <van-tab title="只能使用范围" name="b">
          <wh-mobile-list
            ref="listTable"
            class="list"
            :get-list-data="getListData"
            :extra-params="extraParams2"
            :data-src="dataSrc"
          >
            <template v-slot="{list}">
              <van-collapse v-model="activeName" accordion>
                <van-collapse-item v-for="i in list" :key="i.id" :title="i.name" :name="i.id">
                  <div><label>禁用原因:</label><p>{{ i.reason }}</p></div>
                  <div><label>禁用日期:</label><p>{{ i.ban_date }}</p></div>
                  <div><label>公告号/发布日期:</label><p>{{ i.notify_date }}</p></div>
                  <div><label>只能在这些范围使用:</label><p>{{ i.scope? i.scope.join():'' }}</p></div>
                  <div><label>简介:</label><p>{{ i.info }}</p></div>
                </van-collapse-item>
              </van-collapse>
            </template>
          </wh-mobile-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
export default {
  components: { WhMobileList },
  data() {
    return {
      extraParams1: {
        limit_type: 0
      },
      extraParams2: {
        limit_type: 1
      },
      activeName: '',
      active: 'a',
      dataSrc: 'https://sit.whhda.xyz/traceTools/inputLimitPesticide/find'
    }
  },
  methods: {
    getListData(res) {
      return res.data.items
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
.list {
  max-height: calc(100vh - 90px);
}
.ban{
  .main{
    height: 100%;
    margin-top: 40px;
    label{
      color: #333;
      font-size: 13px;
    }
    p{
      font-size: 12px;
    }
  }
}

</style>
